import http from '../../utils/fetch';
export default {

    baseurl:'/api/swyl/v1/demo/bscClueAgentOwner',

    selectById(query){
        return http({
            url: this.baseurl + '/selectById',
            method: 'post',
            params: query
        });
    },

    updateById(query){
        return http({
            url: this.baseurl + '/updateById',
            method: 'post',
            params: query
        });
    },
    deleteById(query){
        return http({
            url: this.baseurl + '/deleteById',
            method: 'post',
            params: query
        });
    },



    sendMsg(){
        return http.post(this.baseurl + '/sendMsg');
    },
    getwlzhaobiao(){
        return http.post(this.baseurl + '/getwlzhaobiao');
    },


    selectPage(query){
        return http({
            url: this.baseurl + '/selectPage',
            method: 'post',
            params: query
        });
    },


    insert(query){
        return http({
            url: this.baseurl + '/insert',
            method: 'post',
            params: query
        });
    },

    selectClueAgentOwner(query){
        return http({
            url: this.baseurl+'/selectClueAgentOwner',
            method: 'post',
            params: query
        });
    },




}
